import {useCallback, useState} from 'react'

import {
  NavigationState,
  initialNavigationState,
  useNavigationStore,
} from '@progyny/store/navigationStore'

const useNavigation = () => {
  const mergeNav = useNavigationStore((state) => state.mergeNav)
  const replaceNav = useNavigationStore((state) => state.replaceNav)
  const [prev, setPrev] = useState<NavigationState | undefined>(undefined)

  // Reads the current store state at call time so setNav has a stable identity
  const setNav = useCallback(
    (config: NavigationState) => {
      const {hide, hideMenu, variant} = useNavigationStore.getState()
      setPrev({hide, hideMenu, variant})
      mergeNav(config)
    },
    [mergeNav]
  )

  const resetNav = useCallback(() => {
    replaceNav(prev ?? initialNavigationState)
  }, [prev, replaceNav])

  return {setNav, resetNav}
}

export {useNavigation}
